import React from "react";

const Footer = () => {
  return (
    <section className="footer">
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <p className="text-light fw-bold copy">
                Copyright © 2023 &nbsp;
                <a
                  href="https://www.linkedin.com/in/afeef-ali-b63a2b25a"
                  className="name"
                >
                  Mohd Afeef Ali
                </a>{" "}
                . All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
